<script>
import { mapGetters } from 'vuex';
//import alertMixin from 'shared/mixins/alertMixin';
import { required, helpers } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import QRSteps from './../components/QRSteps.vue';
import SocketIO from 'socket.io-client';
import InboxesAPI from 'dashboard/api/inboxes';
//const axios = require('axios');
import axios, * as others from 'axios';
import refresh_wa from 'dashboard/assets/images/channels/refresh_wa.png';
import loading from 'dashboard/assets/images/channels/loader.gif';
import { onBeforeUnmount } from 'vue';
import PhoneNumberInput from 'dashboard/components-next/phonenumberinput/PhoneNumberInput.vue';

const customPhone = (value) => {
  if (!value) return true; // Deja que 'required' maneje el vacío
  const cleanValue = value.replace(/\s+/g, ''); // Quitamos espacios para validar
  return /^\+?[1-9]\d{7,14}$/.test(cleanValue);
};
const shouldBeWebhookUrl = (value = '') =>
  value ? value.startsWith('http') : true;

export default {
  components: {
    PageHeader,
    QRSteps,
    PhoneNumberInput
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      channelName: '',
      images: {
        refresh: refresh_wa,
        loading: loading,
      },
      webhookUrl: import.meta.env.VITE_WHATSBAIL_WEB_API + 'callpicker/webhook',
      whatsappwebNumber: '',
      formattedPhone: '',
      importHistory: false,
      whatsappwebQR: loading,
      chatwootToken: '',
      showQR: false,
      canReloadQR: true,
      socket: null,
    };
  },
  mounted() {},
  created() {
    window.addEventListener('beforeunload', this.unclosed);
  },
  beforeDestroy() {
    console.log('beforeDestroy');
    this.unclosed();
  },
  beforeUnmount() {
    this.closeSocket();
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
      accountId: 'getCurrentAccountId',
    }),
  },
  validations: {
    channelName: { required },
    whatsappwebQR: { required },
    webhookUrl: { shouldBeWebhookUrl },
    whatsappwebNumber: {
      required,
    },
  },
  methods: {
    closeSocket() {
      if (this.socket) {
        console.log('Desconectando socket anterior...');
        this.socket.off(); // Quita todos los listeners
        this.socket.disconnect();
        this.socket = null;
      }
    },
    resetForm() {
      this.channelName = '';
      this.whatsappwebNumber = '';
      this.importHistory = false;
    },
    formatPhone() {
      if (this.whatsappwebNumber) {
        let cleanNumber = this.whatsappwebNumber.replace(/\D/g, ''); 
        
        if (cleanNumber.startsWith('52')) {
          if (cleanNumber.length === 12 && cleanNumber[2] !== '1') {
            this.formattedPhone = '521' + cleanNumber.substring(2);
          } 
          else if (cleanNumber.length === 13 && cleanNumber.startsWith('521')) {
            this.formattedPhone = cleanNumber;
          }
          else if (cleanNumber.length === 11) {
             this.formattedPhone = '521' + cleanNumber.substring(2);
          }
          else {
            this.formattedPhone = cleanNumber;
          }
        } 
        else if (cleanNumber.length === 10) {
          this.formattedPhone = '521' + cleanNumber;
        } 
        else {
          this.formattedPhone = cleanNumber;
        }

        console.log("Resultado final:", this.formattedPhone);
      }
    },
    async initSocketConnection() {
      console.log('Iniciando conexión de Socket');
      
      this.closeSocket();

      const socket_url = import.meta.env.VITE_WHATSBAIL_WEB_WSS;
      this.socket = await SocketIO(socket_url, {
        transports: ['websocket'],
      });

      this.formatPhone();
      const key = btoa(this.formattedPhone);
      
      this.socket.emit('register', {
        phone: this.formattedPhone
      });

      this.socket.on('status', (data) => {
        if (data.key !== key) return;

        switch (data.status) {
          case 'loading':
            this.printQR(data.qr);
            break;
          case 'logged':
            console.log('¡WhatsApp vinculado con éxito!');
            this.handleSuccessfulLogin();
            break;
          case 'failure':
            this.canReloadQR = true;
            this.retryQR();
            break;
        }
      });
    },
    async createChannel() {
      this.v$.$touch();

      if (this.v$.$invalid) {
        console.log("Formulario inválido, deteniendo...");
        return; 
      }

      if (this.showQR) {
        return;
      }

      try {
        const { data } = await InboxesAPI.canCreate();
        if (!data.can_create) {
          useAlert(this.$t('INBOX_MGMT.ADD.WHATAPPWEB.LIMIT_ERROR'));
          return;
        }
      } catch (error) {
        useAlert(this.$t('INBOX_MGMT.ADD.WHATAPPWEB.LIMIT_CHECK_ERROR'));
        return;
      }

      this.showQR = true;
      await this.initSocketConnection();

      setTimeout(() => {
        this.processQRCode();
      }, 500);
    },
    async handleSuccessfulLogin() {
      try {
        console.log('Enviando datos a Rails para crear el canal...');
        
        const apiChannel = await this.$store.dispatch('inboxes/createChannel', {
          name: this.channelName,
          settings: {
            is_disconnected: false,
            number: this.formattedPhone,
            type_api: 'whatsbail',
          },
          channel: {
            type: 'api',
            sub_type: 'whatsbail',
            webhook_url: this.webhookUrl,
            whatsapp_key: btoa(this.formattedPhone),
            whatsappweb_number: this.formattedPhone,
          },
        });

        this.closeSocket();
        
        this.$router.replace({
          name: 'settings_inboxes_add_agents',
          params: { page: 'new', inbox_id: apiChannel.id },
        });
      } catch (error) {
        console.error("Error al crear canal en Rails:", error);
        useAlert(
          error.message || this.$t('INBOX_MGMT.ADD.WHATAPPWEB.LIMIT_ERROR')
        );
        this.canReloadQR = true;
        this.retryQR();
      }
    },
    processQRCode() {
      console.log('processQRCode');
      var self = this;
      if (!self.canReloadQR) {
        return;
      }

      self.canReloadQR = false;
      self.whatsappwebQR = this.images.loading;
      self.formatPhone();
      console.log("WHATSBAIL_WEB_API: "+import.meta.env.VITE_WHATSBAIL_WEB_API);
      var url = import.meta.env.VITE_WHATSBAIL_WEB_API + 'callpicker/register';

      axios
        .post(url, {
          phone: self.formattedPhone,
          import_history: this.importHistory,
        })
        .then((response) => {
          console.log("Respuesta completa del servidor:", response.data);
          if (response.data && response.data.status === 'CONNECTED') {
             console.log('Instancia ya activa. Saltando a éxito.');
             setTimeout(() => {
               useAlert('¡Atención! Este número ya tiene una sesión activa y funcionando.');
             }, 100);
             this.showQR = false;
             this.canReloadQR = true;
             this.closeSocket(); 
             return;
          }
        })
        .catch(function (error) {
          console.log(error);
          self.canReloadQR = true;
          self.retryQR();
        });
    },
    retryQR() {
      console.log('retryQR ' + this.images.refresh);
      this.whatsappwebQR = this.images.refresh;
    },
    printQR(qr) {
      var self = this;
      this.whatsappwebQR = this.images.loading;
      setTimeout(function () {
        self.whatsappwebQR = qr;
      }, 500);
    },
    loggedQR() {
      this.createChannel();
    },
    unclosed() {
      console.log('unclosed');
      if (this.socket) {
        this.socket.emit('unclosed');
      }
    },
  },
};
</script>
<template>
  <div
    class="border border-slate-25 dark:border-slate-800/60 bg-white dark:bg-slate-900 h-full p-6 w-full max-w-full md:w-3/4 md:max-w-[75%] flex-shrink-0 flex-grow-0"
  >
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.WHATAPPWEB.NAME')"
      :header-content="$t('INBOX_MGMT.ADD.WHATAPPWEB.DESC')"
    />
    <form class="row" @submit.prevent="createChannel()">
      <div v-show="!showQR" class="medium-8 columns">
        <label :class="{ error: v$.channelName.$error }">
          {{ $t('INBOX_MGMT.ADD.API_CHANNEL.CHANNEL_NAME.LABEL') }}
          <input
            v-model.trim="channelName"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.API_CHANNEL.CHANNEL_NAME.PLACEHOLDER')"
            @blur="v$.channelName.$touch"
          />
          <span v-if="v$.channelName.$error" class="message">{{
            $t('INBOX_MGMT.ADD.API_CHANNEL.CHANNEL_NAME.ERROR')
          }}</span>
        </label>
      </div>

      <div v-show="!showQR" class="medium-8 columns" :class="{ error: v$.whatsappwebNumber.$error }">
        <label>
          {{ $t('INBOX_MGMT.ADD.WHATAPPWEB.NUMBER.LABEL') }}
        </label>
        <PhoneNumberInput
          v-model.trim="whatsappwebNumber"
          :placeholder="$t('INBOX_MGMT.ADD.WHATAPPWEB.NUMBER.PLACEHOLDER')"
          :show-border="true"
          class="mb-4" 
          style="margin-bottom: 20px;" 
        />
        <span v-if="v$.whatsappwebNumber.$error" class="message">{{
          $t('INBOX_MGMT.ADD.WHATAPPWEB.NUMBER.ERROR')
        }}</span>

        <div class="flex items-center gap-2 mt-2 mb-4">
          <input
            id="importHistory"
            v-model="importHistory"
            type="checkbox"
            class="rounded border-slate-300 dark:border-slate-700 text-woot-500 focus:ring-woot-500 cursor-pointer"
          />
          <label for="importHistory" class="text-sm font-normal cursor-pointer mb-0 text-slate-700 dark:text-slate-200">
            Importar historial
          </label>
        </div>
      </div>

      <div v-show="showQR" class="medium-12 columns">
        <QRSteps
          v-if="showQR"
          :qr-link="whatsappwebQR"
          @retryQr="processQRCode"
        />
      </div>

      <div v-show="!showQR" class="medium-12 columns">
        <woot-submit-button
          :loading="uiFlags.isCreating"
          :button-text="$t('INBOX_MGMT.ADD.WHATAPPWEB.APINAME')"
        />
      </div>
    </form>
  </div>
</template>
